interface BlogCardProps {
  title: string;
  date: string;
  image: string;
}

export function BlogCard({ title, date, image }: BlogCardProps) {
  const newDate = new Date(date);
  return (
    <div className="bg-background-card text-text-primary max-w-[576px]  border p-6 pb-1  rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-200">
      <div className="py-4 pt-0">
        <div className=" aspect-[3/2] rounded-lg relative">
          <img
            src={image}
            alt={title}
            className="w-full h-full rounded-lg object-cover"
          />
        </div>
        <div className="flex-col px-2 pt-2 justify-center items-center">
          <h3 className="text-lg  font-[700]  uppercase">{title}</h3>
          <p className="text-[15px]  uppercase ">
            {newDate.toISOString().split('T')[0]}
          </p>
        </div>
      </div>
    </div>
  );
}
